module.exports = __webpack_public_path__ + "img/angel-1.9a7f2695.jpg";